import React from 'react';
import { Grid } from '@material-ui/core';
import { DataRangeFilter } from '../../../components/DataRangeFilter/DataRangeFilter';
import PageTitle from '../../../components/PageTitle/PageTitle';
import AddTitles from '../../titlesCM/actions/create';
import DrawerNative from '../../../components/DrawerNative';
import { useUserData } from '../../../hooks/context/userUserData.hook';

export default function HeaderTitles(props) {
  const [user] = useUserData();
  const {
    titles,
    isByPublishPost,
    setIsByPublishPost,
    selectedStartDate,
    setSelectedStartDate,
    selectedEndDate,
    setSelectedEndDate,
    setFilterWriter,
    writers,
    filterWriter,
  } = props;
  const {
    dateTypeFilter,
    setDateTypeFilter,
    filterStatus,
    setFilterStatus,
    setPage,
    refetchTitles,
    permissions,
  } = props;

  return (
    <Grid container spacing={0}>
      <Grid item xs={4}>
        <PageTitle title="Titles" />
        {permissions.showAddTitle ? (
          <>
            <br />
            <Grid item xs={2}>
              <DrawerNative title="Titles" labelButtonAction="Add">
                <AddTitles refetch={refetchTitles} writerId={user.id} />
              </DrawerNative>
            </Grid>
          </>
        ) : (
          <></>
        )}
      </Grid>
      <Grid item xs={8}>
        <DataRangeFilter
          showIsPublishPostFilter
          isByPublishPost={isByPublishPost}
          setIsByPublishPost={setIsByPublishPost}
          titles={titles}
          selectedStartDate={selectedStartDate}
          setSelectedStartDate={setSelectedStartDate}
          selectedEndDate={selectedEndDate}
          setSelectedEndDate={setSelectedEndDate}
          dateTypeFilter={dateTypeFilter}
          setDateTypeFilter={setDateTypeFilter}
          filterStatus={filterStatus}
          setFilterStatus={setFilterStatus}
          setPage={setPage}
          writers={writers}
          filterWriter={filterWriter}
          setFilterWriter={setFilterWriter}
          permissions={permissions}
        />
      </Grid>
    </Grid>
  );
}
